// API configuration and utilities for Cloudflare Workers backend

export const apiConfig = {
  baseURL: process.env.REACT_APP_API_URL || 'https://api.fanaticit.co.uk',
  wsURL: process.env.REACT_APP_WS_URL || 'wss://api.fanaticit.co.uk',
  environment: process.env.REACT_APP_ENV || 'development',
  timeout: 10000,
};

// Helper function to construct API URLs
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = apiConfig.baseURL.replace(/\/$/, ''); // Remove trailing slash
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const fullUrl = `${baseUrl}${cleanEndpoint}`;
  
  // Debug logging
  if (apiConfig.environment === 'development') {
    console.log(`🔗 API Request: ${fullUrl}`);
  }
  
  return fullUrl;
};

// Common API request headers
export const getDefaultHeaders = (token?: string): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  return headers;
};

// API endpoints enum for consistency
export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/api/auth/login',
  REGISTER: '/api/auth/register',
  
  // Games
  GAMES: '/api/games',
  GAME_DETAIL: (gameId: string) => `/api/games/${gameId}`,
  GAME_STATS: (gameId: string) => `/api/games/${gameId}/stats`,
  
  // Chat/AI
  CHAT_QUERY: '/api/chat/query',
  CHAT_QUERY_ENHANCED: '/api/chat/query/enhanced',
  CHAT_USAGE: '/api/chat/ai-usage',
  CHAT_TEST: '/api/chat/ai-test',
  
  // Admin (for future use)
  ADMIN_GAMES: '/api/admin/games',
  ADMIN_UPLOAD: '/api/admin/upload/markdown-simple',
} as const;

export default apiConfig;